module.exports = __webpack_public_path__ + "img/Routes.5f84cfab.gif";